module.exports = __webpack_public_path__ + "img/phone-white-shadow.da1889cd.png";